export const LAYOUTS = {
  SIMPLE: 'SIMPLE', // デフォルト値
  WITH_CONTACT: 'WITH_CONTACT',
} as const;
